module.exports = __webpack_public_path__ + "img/bsidd-4.cc6c0079.jpg";